import React, { useState, useEffect, useRef } from "react";

const RecaptchaComponent = (props) => {
    const { setPassedRecaptchaV2 } = props;
    const recaptchaRef = useRef(null);

    useEffect(() => {
        const v2SiteKey = "6Le1tF4oAAAAACdircppueJJ8sZNK6LeDEy52ImD";

        // Initialize reCAPTCHA
        window.grecaptcha.ready(() => {
            window.grecaptcha.render(recaptchaRef.current, {
                'sitekey': v2SiteKey,
                'callback': handleRecaptchaCallback,
                'expired-callback': handleRecaptchaExpiredCallback
            });
        });
    }, []);

    const handleRecaptchaCallback = (response) => {
        // console.log('reCAPTCHA callback response:', response);
        setPassedRecaptchaV2(true);
    };

    const handleRecaptchaExpiredCallback = (response) => {
        setPassedRecaptchaV2(false);
    }

    return (
        <div>
            <div
                ref={recaptchaRef}
                data-sitekey="6Le1tF4oAAAAACdircppueJJ8sZNK6LeDEy52ImD"
                data-callback={handleRecaptchaCallback}
                data-expired-callback={handleRecaptchaExpiredCallback}
            ></div>
        </div>
    );
};

export default RecaptchaComponent;
